import { Autocomplete, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from "formik";
import axios from 'axios';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { Stack } from '@mui/system';
import { Image } from 'cloudinary-react'
import { useUpdatePhonecaseMutation, useGetAllBrandsQuery, useGetAllStoragesQuery, useGetAllColorsQuery, useGetAllGroupsQuery, useGetAllMaterialsQuery, useGetAllModelsQuery, useAddGroupMutation } from '../../../../features/fullApi';
import { basicSchema } from "./validation";
import { useTheme } from '@mui/material/styles';
import { toast } from 'react-hot-toast';

const EditPhonecase = () => {
  
  window.scrollTo(0,0)
  const params = useParams()
  const [phonecase, setPhonecase] = useState({})
  const user = JSON.parse(localStorage.getItem('user'))

  const [reqDone, setReqDone] = useState(false)

  const [brand, setBrand] = useState("");
  const [selectedStorages, setSelectedStorages] = useState([]);
  const [color, setColor] = useState("");
  const [material, setMaterial] = useState("");
  const [group, setGroup] = useState("");
  const [model, setModel] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);

  const {data: brands, error: brandsError, isLoading: isLoadingBrands} = useGetAllBrandsQuery()
  const {data: storages, error: storagesError, isLoading: isLoadingStorages} = useGetAllStoragesQuery()
  const {data: colors, error: colorsError, isLoading: isLoadingColors} = useGetAllColorsQuery()
  const {data: groups, error: groupsError, isLoading: isLoadingGroups} = useGetAllGroupsQuery()
  const {data: materials, error: materialsError, isLoading: isLoadingMaterials} = useGetAllMaterialsQuery()
  const {data: models, error: modelsError, isLoading: isLoadingModels} = useGetAllModelsQuery()



  useEffect(() => {
    const getPhonecase = async () => {
      const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/phonecases/find/${params.id}`)
      .then(res => {
        setPhonecase(res.data)
        setReqDone(true)
      })
      .catch(err => console.log(err))
    }
    getPhonecase()
  }, [])


  const [getCallColor, setCallGetColor] = useState(false)
  const [getCallMaterial, setCallGetMaterial] = useState(false)
  const [getCallModel, setCallGetModel] = useState(false)
  const [getCallBrand, setCallGetBrand] = useState(false)


 useEffect(() => {
  const getBrand = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/brands/find/${phonecase.brandId}`)
    .then(res => {
      console.log("res.data", res.data)
      setBrand(res.data)
    })
    .catch(err => console.log(err))
  }
  getBrand()
}, [reqDone, getCallBrand])



useEffect(() => {
  const getModel = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/models/find/${phonecase.modelId}`)
    .then(res => {
      setModel(res.data)
    })
    .catch(err => console.log(err))
  }
  getModel()
}, [reqDone, getCallModel])



useEffect(() => {
  const getColor = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/colors/find/${phonecase.colorId}`)
    .then(res => {
      setColor(res.data)
    })
    .catch(err => console.log(err))
  }
  getColor()
}, [reqDone, getCallColor])


useEffect(() => {
  const getMaterial = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/materials/find/${phonecase.materialId}`)
    .then(res => {
      setMaterial(res.data)
    })
    .catch(err => console.log(err))
  }
  getMaterial()
}, [reqDone, getCallMaterial])

useEffect(() => {
  const getGroup = async () => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/groups/find/${phonecase.groupId}`)
    .then(res => {
      setGroup(res.data)
    })
    .catch(err => console.log(err))
  }
  getGroup()
}, [reqDone])


  useEffect(() => {
    values.brands = brands
  }, [brands])

  useEffect(() => {
    values.groups = groups
  }, [groups])

  useEffect(() => {
    values.storages = storages
  }, [storages])

  useEffect(() => {
    values.colors = colors
  }, [colors])

  useEffect(() => {
    values.materials = materials
  }, [materials])

  useEffect(() => {
    values.models = models
  }, [models])

  const handleBrand = async (event) => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/brands/find/${event.target.value}`)
    .then(res => {
      setBrand(res.data)
    })
    .catch(err => console.log(err))
  };

  const handleColor = async (event) => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/colors/find/${event.target.value}`)
    .then(res => {
      setColor(res.data)
    })
    .catch(err => console.log(err))
  };

  const handleGroup = (event) => {
    setGroup(event.target.value);
  };

  const handleMaterial = async (event) => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/materials/find/${event.target.value}`)
    .then(res => {
      setMaterial(res.data)
    })
    .catch(err => console.log(err))
  };

  const handleModel = async (event) => {
    const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/models/find/${event.target.value}`)
    .then(res => {
      setModel(res.data)
    })
    .catch(err => console.log(err))
  };




useEffect(() => {
      const fields = ['desc', 'img', 'brandId', 'groupId','quantity', 'colorId', 'materialId', 'modelId', 'price'];
      fields.forEach(field => setFieldValue(field, phonecase[field], false));
}, [phonecase]);

const [phonecaseImgLink, setPhonecaseImgLink] = useState(phonecase.img)
const [showBtn, setShowBtn] = useState(false)
const uploadImage = async () => {
  const formData = new FormData()
  formData.append("file", selectedFile)
  formData.append("upload_preset", "zt8iigue")
  const data = await axios.post("https://api.cloudinary.com/v1_1/deqqgmfxk/image/upload", formData)
  .then(res => {
    setPhonecaseImgLink(res.data.secure_url)
    setShowBtn(true)
  })
};

function inFirstOnly(list1, list2) {
  return operation(list1, list2);
}

function operation(list1, list2, isUnion) {
  var result = [];
  
  for (var i = 0; i < list1.length; i++) {
      var item1 = list1[i],
          found = false;
      for (var j = 0; j < list2.length && !found; j++) {
          found = item1._id === list2[j]._id
      }
      if (found === !!isUnion) {
          result.push(item1);
      }
  }

  setOptionz(result)
  return result;
}

const [check, setCheck] = useState(true)

const [optionz, setOptionz] = useState([])
if(check) {
  if(selectedStorages?.length >= phonecase?.storages?.length) {
    console.log("storages", storages)
    console.log("selectedStorages", selectedStorages)
    let options = inFirstOnly(storages, selectedStorages)
    setOptionz(options)
    setCheck(false)
  }
}

const [updatePhonecase] = useUpdatePhonecaseMutation()

//constructing the boolean colors checked array
const [groupsObj, setGroupsObj] = useState({})
  
        useEffect(() => {
          if(!isLoadingGroups) {
            console.log("GROUPS#####", groups)
            Object.keys(groups).forEach(ele => {
              let key = groups[ele].groupName
                groupsObj[key] = groups[ele]._id;
            });
          }
}, [groups, isLoadingGroups])
const [addGroup] = useAddGroupMutation()

const onSubmit = async(values, actions) => {
  if(groupsObj[brand.brandName + " " + model.modelName + " " + material.materialName]?.length>0) {
    updatePhonecase({_id: phonecase._id, title:"Case " + brand.brandName + " " + model.modelName + " " + color.colorName + " " + material.materialName, desc: values.desc, materialId: material._id, modelId: model._id, groupId: groupsObj[brand.brandName + " " + model.modelName + " " + material.materialName], brandId: brand._id, colorId: color._id, price: values.price, quantity: values.quantity, img: phonecaseImgLink}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    })
    .then(res => {
      toast.success(`Case ${brand.brandName} ${model.modelName} ${color.colorName} ${material.materialName} successfully created`)
    })
    .catch((e) => {
      console.log("e is", e)
    })
} else {
  addGroup({groupName: brand.brandName + " " + model.modelName + " " + material.materialName})
  .then(res => {
    updatePhonecase({_id: phonecase._id, title:"Case " + brand.brandName + " " + model.modelName + " " + color.colorName + " " + material.materialName, desc: values.desc, materialId: material._id, modelId: model._id, groupId: res.data._id, brandId: brand._id, colorId: color._id, price: values.price, quantity: values.quantity, img: phonecaseImgLink}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    })
    .then(res => {
      toast.success(`${brand.brandName + " " + model.modelName + " " + color.colorName + " "} successfully created`)
    })
    .catch((e) => {
      toast("Product already exists")
      console.log("e is", e)
    })
  })
  .catch(err => {
    console.log("error when creating new group")
  })
}
navigate('/phonecases/1')
}

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      title: phonecase?.title,
      desc: phonecase?.desc,
      img: phonecase?.img,
      brand: phonecase?.brandId,
      group: phonecase?.groupId,
      model: phonecase?.modelId,
      color: phonecase?.colorId,
      material: phonecase?.materialId,
      price: phonecase?.price,
      quantity: phonecase?.quantity
    },
    validationSchema: basicSchema,
    onSubmit,
  });

  const navigate = useNavigate()

  const onFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    uploadImage()
  };

  const theme = useTheme()

  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));
  const isLg= useMediaQuery(theme.breakpoints.down('lg'));
  const isXl= useMediaQuery(theme.breakpoints.down('xl'));

  const renderMobileEditPhonecase = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""} style={{width:'100%', height:'100%'}}>

    {(phonecase && color && brand && model && material) &&
    <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
      <h3 className="center" style={{marginTop: '70px'}}>Edit {phonecase.title}</h3>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <TextField
          id="desc"
          type="text"
          margin="dense"
          value={values.desc}
          onChange={handleChange}
          onBlur={handleBlur}
          focused
          label={"Desc"}
          sx={{
            "& .MuiInputBase-root": {
                height: 40
          }}}
        />
      </FormControl>
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}

      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'}}>
        <Image cloudName="deqqgmfxk"  publicId={phonecaseImgLink ? phonecaseImgLink : phonecase.img} style={{width: '200px', height: '200px', objectFit:'cover', objectPosition:'center'}}/>     
      </div>
      <Stack direction="row" justifyContent="space-between" sx={{marginBottom: '10px'}}>
          <Button  sx={{width: '150px'}} variant="contained" color="secondary" size="small" component="label">
            Upload
            <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
          </Button>
          <Button variant="contained" size="small" sx={{width: '150px'}} onClick={() => uploadImage()}>Save to cloud</Button>
        </Stack>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
        id="desc"
        type="text"
        margin="dense"
        value={values.desc}
        onChange={handleChange}
        onBlur={handleBlur}
        label={"Desc"}
        multiline
        rows={5}
        focused
      />
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand._id}
                    label="Brand"
                    focused
                    onChange={handleBrand}
                    name="brand"
                    margin="dense"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="model">Model</InputLabel>
                  <Select
                    id="model"
                    value={model._id}
                    label="Model"
                    onChange={handleModel}
                    name="model"
                  >
                      {models?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.modelName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>


      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color._id}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="material">Material</InputLabel>
                  <Select
                    id="material"
                    value={material._id}
                    label="Material"
                    onChange={handleMaterial}
                    name="material"
                  >
                      {materials?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.materialName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
          id="quantity"
          type="number"
          margin="dense"
          value={values.quantity}
          focused
          onChange={handleChange}
          onBlur={handleBlur}
          label={"Quantity"}
          size="small"
        />
      </FormControl>
      {errors.quantity && touched.quantity && (
        <p className="error">{errors.quantity}</p>
      )}

    <FormControl fullWidth style={{marginBottom: '10px'}}>
    <TextField
        id="price"
        type="number"
        margin="dense"
        value={values.price}
        onChange={handleChange}
        onBlur={handleBlur}
        label={"Price"}
        focused
        size="small"
      />
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}
      </FormControl>


      <div className="btnContainer">
        <Stack direction="row" spacing={2}>
          {phonecase?.img ?
              (<Button variant="contained" size="small"color="primary" id="submitBtn" type="submit">
              Update
            </Button>) : "Please upload a phonecase image and you will be able to submit"
          } 
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/smartphones")}>
            Shop
          </Button>
        </Stack>
      </div>
    </form>
  }

  </div>
  )

  const renderTabletEditPhonecase = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""}>

    {(phonecase) &&
    <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
      <Typography variant="h6" className="center">Edit Phonecase {phonecase.title}</Typography>
      <TextField
        id="title"
        type="text"
        value={values.title}    
        onChange={handleChange}
        onBlur={handleBlur}
        label={values.title ? "" : "Title"}
        margin="dense"
      />
      {errors.title && touched.title && <p className="error">{errors.title}</p>}

      <TextField
        id="desc"
        type="text"
        margin="dense"
        value={values.desc}
        onChange={handleChange}
        onBlur={handleBlur}
        label={values.desc ? "" : "Desc"}
      />
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}

      <Image cloudName="deqqgmfxk"  publicId={phonecaseImgLink ? phonecaseImgLink : phonecase.img} style={{width: '300px', height: '300px', objectFit:'cover', objectPosition:'center'}}/>
      <Stack style={{marginBottom:'20px'}}>
        <Button variant="contained" color="secondary" component="label" style={{marginBottom: '10px'}}>
          Upload
          <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
        </Button>
        <Button variant="contained" size="small" style={{width: '250px'}} onClick={() => uploadImage()}>Save Image</Button>
      </Stack>


      <FormControl fullWidth>
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand}
                    label="Brand"
                    onChange={handleBrand}
                    name="brand"
                    margin="dense"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>


    {(selectedStorages.length >= phonecase?.storages?.length) &&
    (
      <Autocomplete
        multiple
        id="tags-standard"
        freeSolo
        options={optionz}
        getOptionLabel={(option) => (option.amount + option.type)}
        defaultValue={selectedStorages}
        name="storages"
        onChange={(e, value) => {
          setCheck(true)
          setSelectedStorages(value)
          phonecase.storages = value
          inFirstOnly(storages, value)
          setFieldValue("storages", value);
        }}
        style={{marginBottom: '15px'}}
        renderInput={(params) => (
          <TextField
            {...params}
            margin="dense"
            variant="standard"
            label="Storages options"
            placeholder="Storages"
            value={values.storages}
          />
        )}
      />
    )}

      <FormControl fullWidth>
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

    <TextField
        id="price"
        type="number"
        margin="dense"
        value={values.price}
        onChange={handleChange}
        onBlur={handleBlur}
        label={values.price ? "" : "Price"}
      />
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}

      <div className="btnContainer">
        <Stack direction="row" spacing={2}>
          {phonecase?.img ?
              (<Button variant="contained" size="small"color="primary" id="submitBtn" type="submit">
              Update
            </Button>) : "Please upload a phonecase image and you will be able to submit"
          } 
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/smartphones/1")}>
            Shop
          </Button>
        </Stack>
      </div>
    </form>
  }

  </div>
  )

  const renderDesktopEditPhonecase = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""}>

    {(phonecase && color && brand && model && material) &&
    <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
    <Typography style={{marginTop:'64px', marginBottom:'10px'}} variant="h5" className="center">Edit Phonecase {phonecase.title}</Typography> 

      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
        id="desc"
        type="text"
        margin="dense"
        value={values.desc}
        onChange={handleChange}
        onBlur={handleBlur}
        label={"Desc"}
        multiline
        rows={5}
        focused
      />
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}
      </FormControl>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'}}>
        <Image cloudName="deqqgmfxk"  publicId={phonecaseImgLink ? phonecaseImgLink : phonecase.img} style={{width: '300px', height: '300px', objectFit:'cover', objectPosition:'center'}}/>
      </div>
      <Stack direction="row" justifyContent="space-between" style={{marginBottom:'15px', marginTop:'15px'}}>
        <Button size="medium" sx={{width: '150px'}} variant="contained" color="secondary"  component="label">
          Upload
          <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
        </Button>
        <Button size="medium" variant="contained"  sx={{width: '150px'}} onClick={() => uploadImage()}>Save to cloud</Button>
      </Stack>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand._id}
                    label="Brand"
                    focused
                    onChange={handleBrand}
                    name="brand"
                    margin="dense"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="model">Model</InputLabel>
                  <Select
                    id="model"
                    value={model._id}
                    label="Model"
                    onChange={handleModel}
                    name="model"
                  >
                      {models?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.modelName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>


      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color._id}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="material">Material</InputLabel>
                  <Select
                    id="material"
                    value={material._id}
                    label="Material"
                    onChange={handleMaterial}
                    name="material"
                  >
                      {materials?.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.materialName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
          id="quantity"
          type="number"
          margin="dense"
          value={values.quantity}
          focused
          onChange={handleChange}
          onBlur={handleBlur}
          label={"Quantity"}
        />
      </FormControl>
      {errors.quantity && touched.quantity && (
        <p className="error">{errors.quantity}</p>
      )}

    <FormControl fullWidth style={{marginBottom: '10px'}}>
    <TextField
        id="price"
        type="number"
        margin="dense"
        value={values.price}
        onChange={handleChange}
        onBlur={handleBlur}
        label={"Price"}
        focused
      />
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}
      </FormControl>
      <div className="btnContainer">
        <Stack direction="row" spacing={2}>
          {phonecase?.img ?
              (<Button variant="contained" size="small"color="primary" id="submitBtn" type="submit">
              Update
            </Button>) : "Please upload a phonecase image and you will be able to submit"
          } 
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/phonecases/page=1")}>
            Shop
          </Button>
        </Stack>
      </div>
    </form>
  }

  </div>
  )

  return (
    <div>
        {
        (isXs) ?  renderMobileEditPhonecase() : 
        (isSm) ? renderMobileEditPhonecase() :
        (isMd) ? renderMobileEditPhonecase() :
        renderDesktopEditPhonecase()
      }
    </div>
  );
}

export default EditPhonecase